import React, { useState, useEffect,useCallback } from "react";
import {
  Descriptions,
  Row,
  Col,
  DatePicker,
  TimePicker,
  Button,
  Card,
  Badge,
  
} from "antd";
import { useDispatch, useSelector } from "react-redux";
import axios from "axios";
import { showLoading, hideLoading } from "../redux/alertsSlice";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-hot-toast";
import moment from "moment";
import Layout from "../components/layout";
import imageSrc from "../components/image/appointment.png";



function BookAppointment() {
  const [isAvailable, setIsAvailable] = useState(false);
  const navigate = useNavigate();
  const [date, setDate] = useState(null);
  const [time, setTime] = useState(moment().format("HH:mm"));
  const { user } = useSelector((state) => state.user);
  const params = useParams();
  const [doctor, setDoctor] = useState(null);
  const dispatch = useDispatch();




  const getDoctorData = useCallback(async () => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/doctor/get-doctor-info-by-id",
        { doctorId: params.doctorId },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      dispatch(hideLoading());
      if (response.data.success) {
        setDoctor(response.data.data);
      }
    } catch (error) {
      dispatch(hideLoading());
    }
  },
  [dispatch, params.doctorId]);


  useEffect(() => {
    getDoctorData();
  }, [getDoctorData]);




  const checkavailability = async () => {
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/bookAppointment/check-availability",
        { doctorId: params.doctorId, date, time },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
      dispatch(hideLoading());
  
      if (response.data.success) {
        toast.success(response.data.message); // Show toast immediately
        setIsAvailable(true);
        
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error Booking Appointment!");
      dispatch(hideLoading());
    }
  };
  

  const bookNow = async () => {
    if (!date || !time || time === "00:00") {
      toast.error("Please select a valid time.");
      return;
    }
  
    const formattedTime = moment(time, "HH:mm").format("HH:mm"); // Ensure correct format
    console.log("Final Time Sent to API:", formattedTime);
  
    setIsAvailable(false);
    try {
      dispatch(showLoading());
      const response = await axios.post(
        "/api/bookAppointment/book-appointment",
        {
          doctorId: params.doctorId,
          userId: user._id,
          doctorInfo: doctor,
          userInfo: user,
          date,
          time: formattedTime,
        },
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` },
        }
      );
  
      dispatch(hideLoading());
  
      if (response.data.success) {
        toast.success(response.data.message);
        setTimeout(() => {
          navigate("/appointments");
        }, 1500);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      dispatch(hideLoading());
      toast.error(error.response?.data?.message || "Error Booking Appointment!");
    }
  };
  


  const handleDateChange = (value) => {
    setDate(moment(value).format("DD-MM-YYYY"));
    setIsAvailable(false);
  };

  const handleTimeChange = (value) => {
    if (value) {
      const formattedTime = moment(value, "HH:mm").format("HH:mm");
      console.log("Time Selected:", formattedTime); // Debugging
      setTime(formattedTime);
    } else {
      setTime(null); // Reset if no value is selected
    }
  };
  
  
  

  return (
    <Layout>
      {doctor && (
         <div className="book-appointment-container" style={{ padding: 20 }}>
          <Card className="doctor-card" style={{ padding: 20, margin: "auto", maxWidth: 800 }}>
          <Row gutter={[20, 20]} align="middle">
              <Col span={12} sm={24} xs={24} lg={12}>
                <img
                  src={imageSrc}
                  alt="Book Now"
                  className="book-now-img"
                  width="100%"
                  height="100%"
                />
              </Col>
              <Col span={12} sm={24} xs={24} lg={12}>
                <Descriptions title="Doctor Information" layout="vertical">
                  <Descriptions.Item label="Doctor Name">
                  <i className="ri-user-heart-fill" style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}></i>
                    {doctor.firstName} {doctor.lastName}
                  </Descriptions.Item>
                   <Descriptions.Item label="Service">
                    <i
                       className="ri-service-fill"
                      style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}
                    ></i>
                    {doctor.service}
                  </Descriptions.Item>
                  <Descriptions.Item label="Location">
                    <i
                       className="ri-map-pin-fill"
                      style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}
                    ></i>
                    {doctor.location}
                  </Descriptions.Item>
                  <Descriptions.Item label="Doctor Available Days">
  <span style={{ marginRight: "5px", position: "relative", display: "inline-block" }}>
    <Badge count={doctor.clinicDay?.length} offset={[-15, -8]}>
      <i
        className="ri-calendar-todo-fill"
        style={{ fontSize: "38px", color: "rgba(48,142,84,1)" }}
      ></i>
    </Badge>
  </span>
  {doctor.clinicDay.map((day, index) => (
                       <span 
                       key={index} 
                       className="badge badge-light m-1" 
                       style={{ color:"#217559", backgroundColor: "#f8f9fa"  }} // Light badge with black text
                     >
                       {day}
                     </span>
                      ))}
</Descriptions.Item>
  </Descriptions><br></br>
  <Descriptions.Item label="Time Interval">
    <i className="ri-calendar-schedule-fill" style={{ marginRight: 8, color: "rgba(48,142,84,1)" }}></i>
    {doctor.appointmentTime[0]} - {doctor.appointmentTime[1]}
  </Descriptions.Item>
  <label style={{ fontWeight: "bold", marginTop: "20px", display: "block", fontSize:"35px"}}>
                 Select Book Date
                 </label>
                <div className="date-time-picker">
                   <DatePicker
                 format="DD-MM-YYYY"
                onChange={handleDateChange}
               className="mr-3"
                />
                <TimePicker
               format="HH:mm"
               onChange={handleTimeChange}
               value={time ? moment(time, "HH:mm") : null}
               style={{ display: "none" }} // Hides the TimePicker
                 />

                </div>

                <div className="button-group">
                  {!isAvailable ? (
                    <Button
                      type="primary"
                      className="btn-primary"
                      onClick={checkavailability}
                    >
                      Confirm Availability
                    </Button>
                  ) : (
                    <Button
                      type="primary"
                      className="btn-primary"
                      onClick={bookNow}
                    >
                      Book Now
                    </Button>
                  )}
                </div>
              </Col>
            </Row>
          </Card>
        </div>
      )}
    </Layout>
  );
}

export default BookAppointment;
